import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

const StyledTooltipTrigger = styled.div`
  border-radius: 50%;
  background-color: ${getColor('neonCarrot')};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  margin-left: 1rem;
  color: #fff;

  &:hover {
    cursor: default;
  }
`;

const TooltipTrigger = ({ value }) => {
  return <StyledTooltipTrigger>+{value}</StyledTooltipTrigger>;
};

export default TooltipTrigger;
